var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strata-report-component"},[_c('vue-form',{ref:"form",attrs:{"options":{ permalink: 'generateStrataReport' }}},[_c('div',{staticClass:"card-header",attrs:{"slot":"title"},slot:"title"},[_vm._v("Generate Report")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20f3b4c8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/StrataReport.vue
// module id = 1136
// module chunks = 1